import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IMoreInformation } from '../../interfaces/more-information.interface';

@Component({
    selector: 'roblex-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
    /**
     * Our schedule of footer component
     */
    @Input() ourSchedule: any;
    /**
     * Contact email of footer component
     */
    @Input() contactEmail: any;
    /**
     * Information  of footer component
     */
    @Input() information: any;
    /**
     * Social  of footer component
     */
    @Input() social: any[];
    /**
     * App stores of footer component
     */
    @Input() appStores: any;
    /**
     * show return of footer component
     */
    @Input() showReturn = false;
    /**
     * Input number versión of footer component
     */
    @Input() version: string;
    /**
     * Input background of footer component
     */
    @Input() background = 'bg-color-blue-light';
    /**
     * Input more informations of footer component
     */
    @Input() moreInformations: IMoreInformation[];
    /**
     * Output  of footer component
     */
    @Output() router: EventEmitter<IMoreInformation> = new EventEmitter();
    /**
     * Output return home of footer component
     */
    @Output() returnHome: EventEmitter<void> = new EventEmitter();
    /**
     * Creates an instance of footer component.
     */
    constructor() {}
    /**
     * on init
     */
    ngOnInit(): void {}
    /**
     * Determines whether click route on
     * @param moreInformation IMoreInformation
     */
    onClickRoute(moreInformation: IMoreInformation): void {
        this.router.emit(moreInformation);
    }
    /**
     * Determines whether click return home on
     */
    onClickReturnHome() {
        this.returnHome.emit();
    }
}
